import { fetcher } from "helpers/fetcher";

import { TGetHistoryAssociationReq, TGetHistoryAssociationRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getHistoryAssociation = async (
  params?: TGetHistoryAssociationReq
) => {
  return await fetcher<TGetHistoryAssociationRes, any>(
    ENDPOINT.BU.GET_HISTORY_ASSOCIATION,
    {
      params: params,
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.BU.GET_HISTORY_ASSOCIATION.version,
      },
    }
  );
};

export const queryGetHistoryAssociation = async (
  params?: TGetHistoryAssociationReq
) => {
  return (await getHistoryAssociation(params)).data;
};

queryGetHistoryAssociation._key = (params?: TGetHistoryAssociationReq) => [
  ENDPOINT.BU.GET_HISTORY_ASSOCIATION.url,
  params,
];
